import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './Subtitle.scss';

interface SubtitleProps {
    text: string | GenericLazyString;
}

export const Subtitle: React.FunctionComponent<SubtitleProps> = (props) => {
    const { text } = props;

    return (
        <h3
            className="things-to-do-subtitle eds-l-pad-hor-3 eds-l-pad-bot-6"
            data-testid="'things-to-do-subtitle'"
        >
            {text}
        </h3>
    );
};
